import { ReactNode } from 'react';
import { Heading, HeadingProps } from '../../typography';
import { useDrawerHeaderContext } from './drawer-header';

type DrawerTitleProps = HeadingProps;

export function DrawerTitle({
  as = 'h1',
  children,
  ...props
}: DrawerTitleProps): ReactNode {
  const { hasImage } = useDrawerHeaderContext();

  return (
    <Heading {...props} as={as} variant="h3" mt={hasImage ? '2' : '8'}>
      {children}
    </Heading>
  );
}
